import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'translatePercent',
  standalone: false
})
export class TranslatePercentPipe implements PipeTransform {
  transform(val: number, language: string, numberOfDecimals = 1): string {
    if (!val) {
      return '0%';
    }

    const locales = {
      'de-CH': 'de-CH',
      'de-DE': 'de-DE',
      'en-CH': 'en-GB',
      'en-DE': 'en-GB',
      'fr-CH': 'fr-CH'
    };

    // Temporary hack until we upgrade typescript
    const value: {
      toLocaleString: (locale: string) => string;
    } = Number(val).toFixed(numberOfDecimals);

    return `${Number(value).toLocaleString(locales[language])}${language === 'fr-CH' ? ' ' : ''}%`;
  }
}
